import React , {useState} from 'react';
import { useDispatch } from 'react-redux';
import { openDeletePriceModal, openEditPriceModal } from '../../Store/Slices/priceSlice';
import { PaginationDetails } from '../../Utils/Utils';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Pagination , Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';


const PriceList = ({data}) => {
    const dispatch = useDispatch();
    const { page, count, handleChange, _DATA } = PaginationDetails(data);


    const handleEdit = (priceTBLId) => {
        dispatch(openEditPriceModal(priceTBLId));
    };

    const handleDelete = (priceTBLId) => {
        dispatch(openDeletePriceModal(priceTBLId));
    };


    const currentData = _DATA?.currentData() || data;
    const roles = sessionStorage.getItem("roles")


    return (
        <>
            <TableContainer sx={{ height: "43rem" }} >
                <Table  sx={{borderCollapse:'separate' , borderSpacing:'0px 4px' , height:'max-content'}} stickyHeader>
                    <TableHead  >
                        <TableRow >
                            <TableCell  width={150} > PriceTBL Id</TableCell>
                            <TableCell  width={150} > Category </TableCell>
                            <TableCell  width={250} > No of Resource</TableCell>
                            <TableCell  width={250} > No of Hours</TableCell>
                            <TableCell  width={50}> Amount </TableCell>
                            <TableCell align="center" width={"30%"}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody >
                        {currentData.map((price) => (
                            <TableRow  sx={{ height: "30px" }} key={price.priceTBLId}>
                                <TableCell  component='th' scope='row' sx={{ borderBottom: "none", fontWeight: 'bold', width: 100, height: 'auto !important' }}>#{price.priceTBLId}</TableCell>
                                <TableCell sx={{ borderBottom: "none", width: 150, height: 'auto !important' }}>{price.catName}</TableCell>
                                <TableCell sx={{ borderBottom: "none", width: 100, height: 'auto !important' }}>{price.noResId}</TableCell>
                                <TableCell sx={{ borderBottom: "none", width: 100, height: 'auto !important' }}>{price.noHrsId}</TableCell>
                                <TableCell sx={{ borderBottom: "none", width: 100, height: 'auto !important' }}>{price.amount}</TableCell>
                                <TableCell align="center" sx={{ borderBottom: "none", width: '15%', height: 'auto !important' }}>
                                    {roles?.split(",").includes("PRIV_ES_EDIT_PRICE_TBL") ?  (<IconButton onClick={() => handleEdit(price.priceTBLId)}>
                                        <EditIcon />
                                    </IconButton>) : null}
                                    {roles?.split(",").includes("PRIV_ES_DELETE_PRICE_TBL") ?  (<IconButton onClick={() => handleDelete(price.priceTBLId)}>
                                        <DeleteIcon />
                                    </IconButton>) : null}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            
            </TableContainer>
            <Box my={2} display="flex" justifyContent="center">
                <Pagination
                    count={count}
                    page={page}
                    onChange={handleChange}
                    variant='outlined'
                    color="primary"
                    size='large'
                />
            </Box>
                
        
          
        </>
    );
};

export default PriceList;